export const subtitles = {
    "1": {
        "startTime": 0.47400000000000003,
        "endTime": 3.591,
        "transcript": "Uunguciingartenrilkenka-wa. (Yaa, uunguciitanka wii.)",
        "translation": "I haven't figured out what they are. (Yes, I have no idea about them.)"
    },
    "2": {
        "startTime": 3.597,
        "endTime": 4.7219999999999995,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "3": {
        "startTime": 8.394,
        "endTime": 10.894,
        "transcript": "Roll-angllilriakuk-wa waniwa.",
        "translation": "I think we've started rolling."
    },
    "4": {
        "startTime": 17.04,
        "endTime": 27.581,
        "transcript": "William, kitak' nani yuurtellerpenek, maa-i-llu qavcinek allrakungellerpenek qanruarteqerkut.",
        "translation": "William, please tell us where you were born, and how old you are now."
    },
    "5": {
        "startTime": 27.584,
        "endTime": 28.701,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "6": {
        "startTime": 28.895,
        "endTime": 37.775,
        "transcript": "Maa-i wani 1915-aami yuurtellruunga ak'a man'a wani Kusquqviim ilua nepaunaku",
        "translation": "I was born in 1915 long ago when the Kuskokwim here was peaceful"
    },
    "7": {
        "startTime": 37.78,
        "endTime": 41.72,
        "transcript": "Yuut-llu wani waten cav'urluteng.",
        "translation": "And people rowed like this."
    },
    "8": {
        "startTime": 42.048,
        "endTime": 46.018,
        "transcript": "Cav'urluteng-llu neqsurluteng, levaartaunani.",
        "translation": "And they rowed to fish, with no boat motors."
    },
    "9": {
        "startTime": 46.748,
        "endTime": 52.498,
        "transcript": "Maa-i wani qavcinek allrakungsit umyuaqellerpeni, nallunritlerpeni?",
        "translation": "How old are you now from what you think, what you know?"
    },
    "10": {
        "startTime": 52.499,
        "endTime": 55.119,
        "transcript": "Seventy-five-aaryugnarqua.",
        "translation": "I think I'm 75."
    },
    "11": {
        "startTime": 56.621,
        "endTime": 60.151,
        "transcript": "(Yugtun-llu cali atren qanrutekluku.) Callerkuaq.",
        "translation": "(Say your name in Yup'ik too.) Callerkuaq."
    },
    "12": {
        "startTime": 60.166,
        "endTime": 61.786,
        "transcript": "(Callerkuaq?) Yaa.",
        "translation": "(Callerkuaq?) Yes."
    },
    "13": {
        "startTime": 61.794,
        "endTime": 62.554,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "14": {
        "startTime": 63.837,
        "endTime": 72.707,
        "transcript": "Ayagyuallerpeni qaillun caliaqerraallerpenek cali qanruarteqerkut.",
        "translation": "Please tell us about your first work when you were young too."
    },
    "15": {
        "startTime": 73.435,
        "endTime": 80.015,
        "transcript": "Agayuvigmi elders-aarullruunga. Agayuvigmi qallatesteńguaqlua.",
        "translation": "I was one of the elders in church. I would preach in church."
    },
    "16": {
        "startTime": 80.426,
        "endTime": 86.456,
        "transcript": "Ayagyuanun-llu imkunek young people leader-aarulua.",
        "translation": "And for the youth, I was the young people leader."
    },
    "17": {
        "startTime": 87.386,
        "endTime": 97.316,
        "transcript": "Kinguakun-llu council-aanun eklua, IRA Council tamaani '43-am nuniini.",
        "translation": "And after that, I was in the council, IRA Council, back around '43."
    },
    "18": {
        "startTime": 98.073,
        "endTime": 104.043,
        "transcript": "Tamaaken-ll' ayaglua una council-aani alerquuciulqa taqsuunani.",
        "translation": "And since then, I never stopped working with [tribal] council laws."
    },
    "19": {
        "startTime": 104.318,
        "endTime": 115.205,
        "transcript": "Mat'umi-llu Yup'imteńi wangkuta yuullemteńi nutaan alerquun tamana cali nalluvkenaku.",
        "translation": "I also especially know about the traditional instructions of our way of life among Yupiit."
    },
    "20": {
        "startTime": 115.749,
        "endTime": 120.369,
        "transcript": "Ukut-llu cali, elitnauraullrunritua.",
        "translation": "And these, I was not a student."
    },
    "21": {
        "startTime": 120.836,
        "endTime": 130.126,
        "transcript": "Anguyagtem cali federal-aam, Territory of Alaska, taum cali alerquutai murilkelluki.",
        "translation": "And the federal government, the Territory of Alaska, I also observed their laws."
    },
    "22": {
        "startTime": 131.089,
        "endTime": 139.769,
        "transcript": "Elitnauraqlua-ll' imkunek alerquutnek elsingalrianek tangvagluki tamakunek.",
        "translation": "I would also learn by watching these people who were knowledgeable about laws."
    },
    "23": {
        "startTime": 141.926,
        "endTime": 149.376,
        "transcript": "Maa-i wani ernerpak man'a wani Yugni wangkuta arenqiallugutvut taangaq",
        "translation": "These days, this alcohol that is a problem among us Yupiit"
    },
    "24": {
        "startTime": 151.875,
        "endTime": 160.015,
        "transcript": "Qaillun imumi ayuqucillra, maa-i cali Mamterillerni wall'u nunani ayuqsaaquq umgumaluni.",
        "translation": "What it was like in the past, it's still closed here in Bethel or in villages."
    },
    "25": {
        "startTime": 160.019,
        "endTime": 165.859,
        "transcript": "Kitak' qanrutkeqerru qaillun ayuqellra, maa-i-llu cangallrullra.",
        "translation": "Please talk about what it was like, and how it compares to today."
    },
    "26": {
        "startTime": 165.864,
        "endTime": 173.154,
        "transcript": "Nineteen-thirty merkun waten Akacakarralriami niitellruunga.",
        "translation": "In 1930, I heard about [someone drowning in] water in Akacakarralria."
    },
    "27": {
        "startTime": 174.083,
        "endTime": 178.083,
        "transcript": "Tangerrluku-llu mat'um taangam piluku.",
        "translation": "And I saw that alcohol got him."
    },
    "28": {
        "startTime": 178.238,
        "endTime": 185.478,
        "transcript": "Tua-i-ll' kinguakun niitellruunga cali taangakun ellminek nutellriamek.",
        "translation": "Then afterwards, I heard about someone shooting themself under the influence of alcohol."
    },
    "29": {
        "startTime": 185.803,
        "endTime": 190.323,
        "transcript": "Akultuluni. Allrakuani pingatuq.",
        "translation": "They were far apart. I think it was the year after."
    },
    "30": {
        "startTime": 190.387,
        "endTime": 201.957,
        "transcript": "Cali taum kinguani akulturaqerluku yugmek cali niitellrulua up'nerkami cupellrani catailngurmek.",
        "translation": "And quite some time after that, I also heard about a person who'd gone missing in the spring when the ice broke."
    },
    "31": {
        "startTime": 201.965,
        "endTime": 208.895,
        "transcript": "Kiagumainanrani-ll' nataqngatgu cakmavet anelrarluta paqnayugluta.",
        "translation": "And when they found him in the summer, we went downriver to see him."
    },
    "32": {
        "startTime": 208.964,
        "endTime": 212.664,
        "transcript": "Tua-i taukuk taangam piqarraallrak.",
        "translation": "Those are the first ones that alcohol got."
    },
    "33": {
        "startTime": 213.076,
        "endTime": 218.466,
        "transcript": "Tua-i-ll' maaken ayagluni ukaqvanek pinerturiuq.",
        "translation": "Then starting recently from here, it's become common."
    },
    "34": {
        "startTime": 218.478,
        "endTime": 221.938,
        "transcript": "Cukaqapiggluteng tua-i makut tan'gaurluut.",
        "translation": "These boys are short-lived."
    },
    "35": {
        "startTime": 222.743,
        "endTime": 228.273,
        "transcript": "Ikingqallrani-ll' tua-i nutaan kanvelriatun ayuqellruluteng.",
        "translation": "And when it was open, they dropped in great numbers."
    },
    "36": {
        "startTime": 229.062,
        "endTime": 235.902,
        "transcript": "Maa-i-ll' nutaan mat'umi ernemteńi nutaan assiitqapiarluni.",
        "translation": "And in our current days, it's worse than ever."
    },
    "37": {
        "startTime": 237.028,
        "endTime": 247.838,
        "transcript": "Wiinga alingniurlua iliini qavalartua makut wani ayagyuat arenqialata.",
        "translation": "Sometimes, I sleep in fear because these young people are distressing."
    },
    "38": {
        "startTime": 250.856,
        "endTime": 261.636,
        "transcript": "Qaillun wani alerquayugngasikut tamatum tungiinun, qaillun-llu ikayuucugngallemteńek tamatumek naullutelegmek?",
        "translation": "What instructions can you give us about that, and how we can help those who have that addiction?"
    },
    "39": {
        "startTime": 262.262,
        "endTime": 269.362,
        "transcript": "Makut wani arenqiallugutelget naulluutelget [?]-gguq tau͡gaam ciumek kenka.",
        "translation": "With those with that problem and addiction, they say the first is love."
    },
    "40": {
        "startTime": 270.647,
        "endTime": 275.917,
        "transcript": "Cali-ll' tua-i angtuamek atungraata nangrurpek'naki.",
        "translation": "Also, though they do it a lot, do not find fault in them."
    },
    "41": {
        "startTime": 275.98,
        "endTime": 284.5,
        "transcript": "Tau͡gaam cakanirpek'naku waten nutemllarmi yuuyaramteńi kenka, au͡gkut ciuliamta piciryaraat.",
        "translation": "Instead, do not treat them any different according to the love of our ancient way of life, our ancestors' practice."
    },
    "42": {
        "startTime": 285.21,
        "endTime": 289.87,
        "transcript": "Tamana tua-i perriq'apiarluku yuusciigatliniukut.",
        "translation": "We evidently cannot love by completely eradicating that."
    },
    "43": {
        "startTime": 291.522,
        "endTime": 296.172,
        "transcript": "Ilait wani ilaliunritnayukluteng pilartut.",
        "translation": "Some think that no one will socialize with them."
    },
    "44": {
        "startTime": 296.77,
        "endTime": 305.73,
        "transcript": "Cali waten qalarutarkauluki unguvallerkaita pianek qalaruyutiitnek.",
        "translation": "We must also talk to them about wisdom concerning their lives."
    },
    "45": {
        "startTime": 307.023,
        "endTime": 313.973,
        "transcript": "Maa-i, maa-i wani una wani naulluutelek waten qanraqan:",
        "translation": "Now, when a person with an addiction says this:"
    },
    "46": {
        "startTime": 313.981,
        "endTime": 317.751,
        "transcript": "\"Tua-i tang wii taqsugyaaqellrianga. Wiinga meryuumiirucaaqua.\"",
        "translation": "\"I want to quit. I don't want to drink anymore.\""
    },
    "47": {
        "startTime": 317.759,
        "endTime": 323.779,
        "transcript": "Ilaitni waten kiularaput: \"Tua-i-w' inerqularyaaqekemken. Niicunrit'lalriaten.\"",
        "translation": "Sometimes we answer them like this: \"I do admonish you. You don't listen.\""
    },
    "48": {
        "startTime": 323.784,
        "endTime": 332.124,
        "transcript": "Qaillun elpet tamana alerquryugngaceta qaillun kiulallerkamteńek tauna tuaten piyugteqellria?",
        "translation": "How would you instruct us to answer that person who has that desire?"
    },
    "49": {
        "startTime": 333.095,
        "endTime": 339.557,
        "transcript": "Tauna tuaten piyugteqellria qanelqa tua-i ukvekluku pinarqellriaruuq.",
        "translation": "That one who has that desire must believe in what I said."
    },
    "50": {
        "startTime": 341.419,
        "endTime": 348.959,
        "transcript": "Cat ilaitni tanglartua tamana taqsaraq piciuluku akurturluku.",
        "translation": "Sometimes, I see them truly quit that."
    },
    "51": {
        "startTime": 350.802,
        "endTime": 357.112,
        "transcript": "Tau͡gaam maa-i ilait wani taqesciigatut.",
        "translation": "But now, some of them can't quit."
    },
    "52": {
        "startTime": 357.122,
        "endTime": 367.202,
        "transcript": "Mat'umek alcohol-amek tribal court-akun caliangaqertua. Iliini nine-aarulartut tan'gaurluut.",
        "translation": "I work in the tribal court for alcohol. Sometimes, there are nine boys."
    },
    "53": {
        "startTime": 368.233,
        "endTime": 372.343,
        "transcript": "Tau͡gaam wangkuta court-amteggun caliaqluki.",
        "translation": "But we work on them with our court."
    },
    "54": {
        "startTime": 373.153,
        "endTime": 375.893,
        "transcript": "Assikluku wii.",
        "translation": "I like it."
    },
    "55": {
        "startTime": 377.084,
        "endTime": 382.714,
        "transcript": "Tau͡gaam imkut cali elitnaurayagaat waten angtalriit",
        "translation": "But those little children that are this big"
    },
    "56": {
        "startTime": 382.994,
        "endTime": 392.524,
        "transcript": "Quyuita tuavet itrucugngaanka camek akeqnerrlugmek pivkenaki qalarulluki au͡gkut ciuliamta piciryaraicetun.",
        "translation": "I can bring them in altogether without any threat and speak to them as our ancestors used to."
    },
    "57": {
        "startTime": 392.872,
        "endTime": 397.612,
        "transcript": "Ukut tau͡gaam angtuaq imna 20 years, 20 years-alria",
        "translation": "Yet these big ones who are 20 years old"
    },
    "58": {
        "startTime": 397.987,
        "endTime": 407.007,
        "transcript": "Tauna au͡gkutun mikelngurtun caliaqnarqenrituq wangni tuani Yugtarmi qanercetaarvigmi.",
        "translation": "To me, that one cannot be worked with like those children in that Yup'ik teaching space."
    },
    "59": {
        "startTime": 408.324,
        "endTime": 416.954,
        "transcript": "Tau͡gaam pinarqellria tuaken cakmavet uitasngaunaku aaryugluta pikumta.",
        "translation": "But we do not ignore the one that needs it, bring them downriver if we are wary."
    },
    "60": {
        "startTime": 417.941,
        "endTime": 425.411,
        "transcript": "Maa-i man'a nallunritelqa atulqa-llu qanruteksugngaaqa.",
        "translation": "Now, I can speak about what I know and have experienced."
    },
    "61": {
        "startTime": 426.271,
        "endTime": 435.382,
        "transcript": "Ava-i qanertuten wani makut mikelnguut wall'u ayagyuat au͡gkunek qanruyutnek niitelallerpenek qanrut'larniluki.",
        "translation": "You just said that you tell children or young people about the traditional wisdom that you used to hear."
    },
    "62": {
        "startTime": 435.398,
        "endTime": 440.51,
        "transcript": "Kitak' qanruyutnek tamakunek niitelallerpenek taikaniiriqaa.",
        "translation": "Please bring forth that traditional wisdom you used to hear."
    },
    "63": {
        "startTime": 440.517,
        "endTime": 450.762,
        "transcript": "Waten, waten ayuquq: \"Qetunramaa, niiskiu aatan aanan-llu. Niisngakek unguvanaurtuten.\"",
        "translation": "This is what it's like: \"My son, obey your father and mother. Obey them so that you will live.\""
    },
    "64": {
        "startTime": 451.399,
        "endTime": 457.21,
        "transcript": "Tamaa-i tamana au͡gkunun angenrilngurnun qanruyun.",
        "translation": "That's traditional wisdom for [children] who aren't big."
    },
    "65": {
        "startTime": 457.777,
        "endTime": 468.155,
        "transcript": "Cali waten qanrulluku: inarcaraq tekiskan cass'aq camek niiskata egmian utertesqelluki.",
        "translation": "Also tell them this: if they hear something when it's time to go to bed, to go home right away."
    },
    "66": {
        "startTime": 468.604,
        "endTime": 475.047,
        "transcript": "They say that after midnight, in our way of life.",
        "translation": "They say that after midnight, in our way of life."
    },
    "67": {
        "startTime": 475.154,
        "endTime": 482.632,
        "transcript": "Unuum-gguq qukallran kinguani elliraqami avtetuuq yuk.",
        "translation": "They say that when it's after midnight, a person splits."
    },
    "68": {
        "startTime": 483.793,
        "endTime": 487.116,
        "transcript": "Caarkaurrluni tua-i umyugaa qamna.",
        "translation": "Something will happen to his mind inside."
    },
    "69": {
        "startTime": 487.13,
        "endTime": 494.974,
        "transcript": "Enemun itrarkaurrluni, caarkaiturarkaurrluni unuum qukallran kinguani.",
        "translation": "He will go inside the home and act like he has no chores do to after midnight."
    },
    "70": {
        "startTime": 494.981,
        "endTime": 500.848,
        "transcript": "Tamaa-i tamakut au͡gkut ciuliamta tamana cali qanrutkellruat.",
        "translation": "That is what our ancestors spoke about."
    },
    "71": {
        "startTime": 502.43,
        "endTime": 508.564,
        "transcript": "Camek cali arcaqalriamek elpet qaneryullerpenek",
        "translation": "Whatever else that is important that you want to say"
    },
    "72": {
        "startTime": 508.571,
        "endTime": 519.082,
        "transcript": "Alerquutngulliuq, inerquutngulliuq wall'u tua-i wangkuta piciryaramteńek, Yup'igni avani ciuqvallaat piciryaraat",
        "translation": "It may be a traditional instruction, it may be an admonishment, or our traditional ways, the ways of Yupiit long ago"
    },
    "73": {
        "startTime": 519.098,
        "endTime": 523.532,
        "transcript": "Waniw' qaneryullerpenek qanra.",
        "translation": "Now, say something you want to say."
    },
    "74": {
        "startTime": 523.533,
        "endTime": 533.589,
        "transcript": "Avani ciuliamta piciryaraitni camek pitaitellruuq, tau͡gaam qasgiq.",
        "translation": "Back in our ancestors' time, there was nothing but the community house."
    },
    "75": {
        "startTime": 534.365,
        "endTime": 538.398,
        "transcript": "Tuani qasgimi qalarut'lallruitkut.",
        "translation": "They would instruct us there in that community house."
    },
    "76": {
        "startTime": 538.4,
        "endTime": 545.244,
        "transcript": "Tau͡gaam cali enemun itraqama uavet nangertetullruunga.",
        "translation": "But when I went into a house, I would stand out there by the door."
    },
    "77": {
        "startTime": 545.251,
        "endTime": 548.718,
        "transcript": "Qanelriartangqelartuq maken.",
        "translation": "There would be someone instructing here."
    },
    "78": {
        "startTime": 548.726,
        "endTime": 554.015,
        "transcript": "Ukut yuurluuk tua-i piu͡rlurmek pilua.",
        "translation": "These two dear people would speak to me of dear things."
    },
    "79": {
        "startTime": 554.022,
        "endTime": 561.933,
        "transcript": "Uaken-llu tua-i teguyaramek natetmun amllirciiganata, anqercesciiganata-llu.",
        "translation": "And from the [?barriers] out there, we couldn't step anywhere or go anwere either."
    },
    "80": {
        "startTime": 562.105,
        "endTime": 568.816,
        "transcript": "Maa-i wani qalarucilriamek angukengnanrirtua.",
        "translation": "Now, I don't come across people giving instruction anymore."
    },
    "81": {
        "startTime": 569.056,
        "endTime": 575.956,
        "transcript": "Waniwa watua ernemteńi angukengnanrirtua tamakunek.",
        "translation": "In our current days, I don't come across those anymore."
    },
    "82": {
        "startTime": 577.059,
        "endTime": 579.504,
        "transcript": "Ciin tamana tuaten piuga?",
        "translation": "Why is it like that?"
    },
    "83": {
        "startTime": 580.179,
        "endTime": 583.934,
        "transcript": "Nutem piulliniuq ak'a tamaaken ayagluni.",
        "translation": "It's an ancient practice since a long time ago."
    },
    "84": {
        "startTime": 584.141,
        "endTime": 599.03,
        "transcript": "Waten makut Yupiim wangkuk alerquutepuk yuinaat qulen allrakut cipluki cimiyuitelliniuq, nepliyuunani.",
        "translation": "Our Yup'ik instructions do not change after over a hundred years, and it does not create unrest."
    },
    "85": {
        "startTime": 599.033,
        "endTime": 606.199,
        "transcript": "Nepaitnamek tau͡gaam qaneryugngaluni. Nepaitnamek yuk inerquryugngaluki.",
        "translation": "But one can talk about peace. A person can admonish them for peace."
    },
    "86": {
        "startTime": 607.21,
        "endTime": 617.477,
        "transcript": "Cali waten nunat nunarraat angayuqangqetullrulliniluteng tegganermek ataucimek ayuqucirturteḿek.",
        "translation": "Also, small villages would have leaders, one elder who was an instructor."
    },
    "87": {
        "startTime": 617.483,
        "endTime": 620.561,
        "transcript": "Tua-i tauna atanvagtun pitaluni.",
        "translation": "That person was like a great authority."
    },
    "88": {
        "startTime": 621.097,
        "endTime": 633.097,
        "transcript": "Tamarmeng nunarraat, tanglallruunga wii imumi, uani-ll' Napaskiarmi, nunarraat makut Ayalpiit tuaten un'gani aptukait.",
        "translation": "Every village, I used to see them a long time ago, and downriver in Napaskiak, even this little village that they call Ayalpiit."
    },
    "89": {
        "startTime": 634.3,
        "endTime": 640.611,
        "transcript": "Ava-i cali qanertuten ayagyuat qanruyutnek niitnanrirniluki.",
        "translation": "You also just said that young people don't hear traditional wisdom anymore."
    },
    "90": {
        "startTime": 640.64,
        "endTime": 647.351,
        "transcript": "Makut pinrirniluki. Ciin tamana tuaten pia, piuga?",
        "translation": "That these don't [hear them] anymore. Why is this so?"
    },
    "91": {
        "startTime": 647.546,
        "endTime": 658.624,
        "transcript": "Tuaten piungan mat'um wani state patuqataakut wangkuta.",
        "translation": "It's like that because this state is going to overshadow us."
    },
    "92": {
        "startTime": 658.968,
        "endTime": 661.413,
        "transcript": "Waten qaingirluta.",
        "translation": "Covering us like this."
    },
    "93": {
        "startTime": 662.788,
        "endTime": 669.533,
        "transcript": "Wangkuta wani ayagnillruukut mat'umek aprumalriamek Yup'ik Nation.",
        "translation": "We started what is called the Yup'ik Nation."
    },
    "94": {
        "startTime": 669.533,
        "endTime": 672.856,
        "transcript": "Nutemllarmek Yuuyaramek wii pila'arqa.",
        "translation": "I call it the Ancient Way of Life."
    },
    "95": {
        "startTime": 673.125,
        "endTime": 682.669,
        "transcript": "Tauna tua-i wani au͡g'umek qaneryugngaunga, \"Atan aanan-llu niisngakek. Umyuan-llu aturpiiqnaku yuugi.\"",
        "translation": "I can also say that, \"Obey your father and mother. And stop following your every inclination as you live.\""
    },
    "96": {
        "startTime": 682.88,
        "endTime": 690.269,
        "transcript": "Maa-i wani kayuringuq, wangni assiriuq uani Akiacuarmi.",
        "translation": "Now, he's getting strong, getting better to me, downriver in Akiachak."
    },
    "97": {
        "startTime": 690.603,
        "endTime": 693.403,
        "transcript": "Tamaryarpiallruyaaquq.",
        "translation": "He was almost lost."
    },
    "98": {
        "startTime": 693.714,
        "endTime": 701.291,
        "transcript": "Tua-i-ll' tauna Willie tan'gaurluulria nateqliqsiu-ll'? Tayim' pitatekliken.",
        "translation": "Then that boy Willie, how close are you in age? You might be the same age as him."
    },
    "99": {
        "startTime": 702.196,
        "endTime": 708.085,
        "transcript": "Makunek cali wangkuta qaneryaramteńek alerquutnek.",
        "translation": "Also, our traditional advice and instructions."
    },
    "100": {
        "startTime": 708.092,
        "endTime": 711.981,
        "transcript": "Pitatni-llu, pitatainek council-aangqertua.",
        "translation": "And those the same age as him, I have a council with his age-mates."
    },
    "101": {
        "startTime": 712.332,
        "endTime": 716.61,
        "transcript": "Taukut wiinga umyuama peng'gartenrirai watua.",
        "translation": "My mind doesn't worry about them now."
    },
    "102": {
        "startTime": 716.934,
        "endTime": 725.223,
        "transcript": "Tau͡gaam cali agyanek anuqnek-llu elitnauqsaitanka, unguvayaranek.",
        "translation": "But I still haven't taught them about the stars and the winds, how to survive."
    },
    "103": {
        "startTime": 725.506,
        "endTime": 731.806,
        "transcript": "Amlleq wani unguvayaraq cali paivcimaksaituq.",
        "translation": "Much of how to survive has still not been brought up."
    },
    "104": {
        "startTime": 735.359,
        "endTime": 741.748,
        "transcript": "Au͡g'umek paqnayungarcetavnga agyanek anuqnek-llu unguvayaraq. Kitak' [qanrutkeqerru].",
        "translation": "You made me curious about survival with the stars and winds. Please [talk about it]."
    },
    "105": {
        "startTime": 741.762,
        "endTime": 746.262,
        "transcript": "Ukut wani nallunritqapiararanka anuqet cetaman.",
        "translation": "I thoroughly know about these four winds."
    },
    "106": {
        "startTime": 746.276,
        "endTime": 748.054,
        "transcript": "Neqnguut.",
        "translation": "They [concern] fish."
    },
    "107": {
        "startTime": 749.151,
        "endTime": 755.662,
        "transcript": "Neqet agiiruciat ukutgun kiagmi nallunritanka neqsurturatullruama.",
        "translation": "I know when fish are coming in the summer through these [winds] because I always went fishing."
    },
    "108": {
        "startTime": 755.769,
        "endTime": 759.347,
        "transcript": "Mikurarkauciat-llu nalluvkenaku.",
        "translation": "And I knew whether they'd be abundant."
    },
    "109": {
        "startTime": 759.679,
        "endTime": 762.99,
        "transcript": "Anuqa atauciq neqaituq.",
        "translation": "One wind [heralds] no fish."
    },
    "110": {
        "startTime": 763.586,
        "endTime": 771.031,
        "transcript": "Una-gguq kanavaq manaryaaqsartuten, keggngaitut.",
        "translation": "They say that the west wind, though you may fish, they won't bite"
    },
    "111": {
        "startTime": 771.859,
        "endTime": 773.614,
        "transcript": "Tua-i taukut...",
        "translation": "Those things..."
    },
    "112": {
        "startTime": 773.624,
        "endTime": 776.39,
        "transcript": "Agyat-llu pagkut murilkeńarqut.",
        "translation": "You must also observe the stars above."
    },
    "113": {
        "startTime": 776.405,
        "endTime": 784.171,
        "transcript": "Pikani ellam qukaani malrunlegnek agyartangqertuq uivelrianek cass'amek.",
        "translation": "Up on the middle of the sky, there are seven spinning stars, a clock."
    },
    "114": {
        "startTime": 784.349,
        "endTime": 794.816,
        "transcript": "Uivekuneng waten malrunelgen, ingna erneq caukagu, arulaiqan caumaurqaku",
        "translation": "If the seven spin like this, when it faces the day over there, when it stops and faces it"
    },
    "115": {
        "startTime": 796.174,
        "endTime": 803.674,
        "transcript": "Agyaq mayurciquq, kiimi angenruluni tanqigceńani. Erenret qamurluki.",
        "translation": "The star will rise, being the only biggest and brightest. It pulls the Days [?constellation?]."
    },
    "116": {
        "startTime": 803.687,
        "endTime": 806.82,
        "transcript": "Tua-i tekisuni-ll' tua-i Erenret alairluteng.",
        "translation": "And when it arrives, the Days appear."
    },
    "117": {
        "startTime": 807.017,
        "endTime": 811.094,
        "transcript": "Tua-i tauna au͡gkut ciuliamta pekengyaraat.",
        "translation": "That was when our ancestors started working."
    },
    "118": {
        "startTime": 811.209,
        "endTime": 816.953,
        "transcript": "Amci pinariniluku. Cassaitelallruameng-llu, cass'anek tangaaksaitelallruameng.",
        "translation": "They said it's time. Also because they had no clocks, because they didn't see clocks."
    },
    "119": {
        "startTime": 817.989,
        "endTime": 825.942,
        "transcript": "Cali waten qaamlleqtaaquneng anuqlirarkauluteng. Anuqmun ataluteng.",
        "translation": "Also, when they [?twinkle] like this, it will be windy. They're connected to the wind."
    },
    "120": {
        "startTime": 825.949,
        "endTime": 833.06,
        "transcript": "Tuaken-llu anuqlingraan pairrluku agyaq anaqan tuaken anuqengarkauluni.",
        "translation": "And though the wind blows from there, if a shooting star goes in the opposite direction, the wind will blow from there."
    },
    "121": {
        "startTime": 833.288,
        "endTime": 840.421,
        "transcript": "Makut maa-i imkut scientist-aanek pilaqait neqnek elisngalriit.",
        "translation": "These are what they call scientists who are knowledgeable about fish."
    },
    "122": {
        "startTime": 841.415,
        "endTime": 848.592,
        "transcript": "Wangkuta tamakuilengramta elisngaaput. Neqsurturatullruama nallunritanka.",
        "translation": "Though we didn't have those, we were knowledgeable about them. I know them because I always used to fish."
    },
    "123": {
        "startTime": 848.753,
        "endTime": 858.098,
        "transcript": "Un'gani-ll' cali uitaqallret cali carvaniurluteng nalluvkenaki. Nallunaunateng.",
        "translation": "And I know the ones that stayed downriver with flowing currents. They're discernible."
    },
    "124": {
        "startTime": 858.1,
        "endTime": 864.363,
        "transcript": "Au͡gkunek tua-i elitnaullemnek, elitnaulallemnek-wa.",
        "translation": "Those are things I learned, what I learned."
    },
    "125": {
        "startTime": 864.371,
        "endTime": 870.749,
        "transcript": "Up'nerkami cali anuqlirtura'arqami neqnek taicinilallruat.",
        "translation": "Also, when it would be windy in the spring, they said that it heralded fish."
    },
    "126": {
        "startTime": 871.488,
        "endTime": 872.855,
        "transcript": "Tua-llu?",
        "translation": "How was that?"
    },
    "127": {
        "startTime": 873.069,
        "endTime": 876.835,
        "transcript": "Tua-i au͡gkut ava-i murilkellrit.",
        "translation": "That's what they observed."
    },
    "128": {
        "startTime": 876.851,
        "endTime": 881.539,
        "transcript": "Ellam mat'um murilkellra assirtuq, ellamta.",
        "translation": "It's good to observe this world, our world."
    },
    "129": {
        "startTime": 882.824,
        "endTime": 884.012,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "130": {
        "startTime": 884.794,
        "endTime": 888.649,
        "transcript": "Camek allamek qaneryukuvet, wall'u qanerkairuskuvet.",
        "translation": "If you want to say anything else, or if you have nothing else to say."
    },
    "131": {
        "startTime": 888.663,
        "endTime": 891.141,
        "transcript": "Tua-i quyaqapigtua watua.",
        "translation": "I'm extremely thankful now."
    },
    "132": {
        "startTime": 891.145,
        "endTime": 898.312,
        "transcript": "Ilagaryuumilaryaaqamci waten mat'ukun nutemllarkun pinalua.",
        "translation": "I want to join you to speak about this ancient way like this."
    },
    "133": {
        "startTime": 898.324,
        "endTime": 906.124,
        "transcript": "Imum-llu, pim, kituulria ima? Twitchell.",
        "translation": "And that person, you know, who was he again? Twitchell."
    },
    "134": {
        "startTime": 906.141,
        "endTime": 910.774,
        "transcript": "Erinaaryullruyaaqua, tau͡gaam anelraqsailama piksaitua.",
        "translation": "I've wanted to speak, but since I didn't go downriver, I haven't."
    },
    "135": {
        "startTime": 912.42,
        "endTime": 914.042,
        "transcript": "Willie...",
        "translation": "Willie..."
    },
    "136": {
        "startTime": 920.457,
        "endTime": 924.946,
        "transcript": "Willie, what's your view on the unification issue?",
        "translation": "Willie, what's your view on the unification issue?"
    },
    "137": {
        "startTime": 924.964,
        "endTime": 936.797,
        "transcript": "The unification issue has been a topic of discussion on AVCP's convention, I would guess for the last four to five years.",
        "translation": "The unification issue has been a topic of discussion on AVCP's convention, I would guess for the last four to five years."
    },
    "138": {
        "startTime": 938.227,
        "endTime": 950.504,
        "transcript": "I think it has made a slow progress, but nevertheless, it takes time to work on issues of relevence that affect the whole region.",
        "translation": "I think it has made a slow progress, but nevertheless, it takes time to work on issues of relevence that affect the whole region."
    },
    "139": {
        "startTime": 950.604,
        "endTime": 963.046,
        "transcript": "Just recently, prior to the convention we had in what we call a Unification Forum Meeting in Imangaq, where the regional nonprofits were invited",
        "translation": "Just recently, prior to the convention we had in what we call a Unification Forum Meeting in Emmonak, where the regional nonprofits were invited"
    },
    "140": {
        "startTime": 963.058,
        "endTime": 977.139,
        "transcript": "And at that time, we discussed with Nunam Kellutestii, Ceńaliulriit, YKHC, AVCP, and Yupiit Nation",
        "translation": "And at that time, we discussed with Nunam Kellutestii, Ceńaliulriit, YKHC, AVCP, and Yupiit Nation"
    },
    "141": {
        "startTime": 977.145,
        "endTime": 989.789,
        "transcript": "About the unification process that AVCP has undertaken based upon the directions that they received from Qipneq's convention resolution.",
        "translation": "About the unification process that AVCP has undertaken based upon the directions that they received from Kipnuk's convention resolution."
    },
    "142": {
        "startTime": 992.112,
        "endTime": 1004.301,
        "transcript": "At that time, we also understand that not many of the people in the villages really understood what the unification meant.",
        "translation": "At that time, we also understand that not many of the people in the villages really understood what the unification meant."
    },
    "143": {
        "startTime": 1004.964,
        "endTime": 1010.587,
        "transcript": "The unification that we're talking about is the development of the regional tribal government.",
        "translation": "The unification that we're talking about is the development of the regional tribal government."
    },
    "144": {
        "startTime": 1011.373,
        "endTime": 1025.325,
        "transcript": "So, at the recommendations at the Imangaq forum meeting was that the nonprofits eats a supporting resolution in concept.",
        "translation": "So, at the recommendations at the Imangaq forum meeting was that the nonprofits eats a supporting resolution in concept."
    },
    "145": {
        "startTime": 1025.343,
        "endTime": 1030.93,
        "transcript": "And we did receive commitment from the organizations that were represented there.",
        "translation": "And we did receive commitment from the organizations that were represented there."
    },
    "146": {
        "startTime": 1030.935,
        "endTime": 1042.235,
        "transcript": "I believe that one of the things that this conventions will talk about how to select people to sit on what it's called a constitutional committee.",
        "translation": "I believe that one of the things that this conventions will talk about how to select people to sit on what it's called a constitutional committee."
    },
    "147": {
        "startTime": 1042.849,
        "endTime": 1058.974,
        "transcript": "The constitutional committees task would be to review how the other indigenous people in the United States, for that matter the whole world, organize under their own types of government.",
        "translation": "The constitutional committees task would be to review how the other indigenous people in the United States, for that matter the whole world, organize under their own types of government."
    },
    "148": {
        "startTime": 1059.442,
        "endTime": 1066.479,
        "transcript": "As stated, as I stated earlier, not everybody understands the tribal government issues.",
        "translation": "As stated, as I stated earlier, not everybody understands the tribal government issues."
    },
    "149": {
        "startTime": 1066.495,
        "endTime": 1071.77,
        "transcript": "So, one of the tasks of this committee would be to educate the people.",
        "translation": "So, one of the tasks of this committee would be to educate the people."
    },
    "150": {
        "startTime": 1071.779,
        "endTime": 1086.279,
        "transcript": "By that, I mean they will be traveling to regional senators to conduct series of public meetings to get people to understand and up to speed of what we would like to achieve under the unification plan.",
        "translation": "By that, I mean they will be traveling to regional senators to conduct series of public meetings to get people to understand and up to speed of what we would like to achieve under the unification plan."
    },
    "151": {
        "startTime": 1086.293,
        "endTime": 1100.118,
        "transcript": "I think one important thing about the unification plan is that the organization and their boards are not the individuals and the authority to develop this government.",
        "translation": "I think one important thing about the unification plan is that the organization and their boards are not the individuals and the authority to develop this government."
    },
    "152": {
        "startTime": 1100.136,
        "endTime": 1114.274,
        "transcript": "Ultimately, the people in the villages, those that have the voting rights, would be the ones to vote on the issue, and then proceed with the development of a government.",
        "translation": "Ultimately, the people in the villages, those that have the voting rights, would be the ones to vote on the issue, and then proceed with the development of a government."
    },
    "153": {
        "startTime": 1114.28,
        "endTime": 1121.092,
        "transcript": "You think you're gonna see a lot of support after this unification forum?",
        "translation": "You think you're gonna see a lot of support after this unification forum?"
    },
    "154": {
        "startTime": 1121.105,
        "endTime": 1122.793,
        "transcript": "I believe so",
        "translation": "I believe so"
    },
    "155": {
        "startTime": 1122.802,
        "endTime": 1137.728,
        "transcript": "Based on some of the comments that I heard that there's still a lot of questions that needs to be brought out and answered, and we had a little bit of taste of that yesterday when I gave the Yupiit Nation report.",
        "translation": "Based on some of the comments that I heard that there's still a lot of questions that needs to be brought out and answered, and we had a little bit of taste of that yesterday when I gave the Yupiit Nation report."
    },
    "156": {
        "startTime": 1137.747,
        "endTime": 1144.36,
        "transcript": "I think, especially the elders, have already understood the concept.",
        "translation": "I think, especially the elders, have already understood the concept."
    },
    "157": {
        "startTime": 1144.363,
        "endTime": 1157.276,
        "transcript": "Bit it's, according to the comments the comments from the elders that I've heard is that these young people that are bilingual aren't too sure whether to go with the old ways or the new ways.",
        "translation": "Bit it's, according to the comments the comments from the elders that I've heard is that these young people that are bilingual aren't too sure whether to go with the old ways or the new ways."
    },
    "158": {
        "startTime": 1157.29,
        "endTime": 1167.84,
        "transcript": "I think in developing a regional government under the unification process, both the old ways and the new ways needs to be incorporated.",
        "translation": "I think in developing a regional government under the unification process, both the old ways and the new ways needs to be incorporated."
    },
    "159": {
        "startTime": 1167.857,
        "endTime": 1174.632,
        "transcript": "So that whatever comes about would best represent the people, and work for the people.",
        "translation": "So that whatever comes about would best represent the people, and work for the people."
    },
    "160": {
        "startTime": 1174.638,
        "endTime": 1177.013,
        "transcript": "One other question.",
        "translation": "One other question."
    },
    "161": {
        "startTime": 1178.047,
        "endTime": 1181.397,
        "transcript": "Apeq'ngilnge'rpet? (Yaa.) Ready-rtuq?",
        "translation": "Though you didn't say? (Yes.) Is it ready?"
    },
    "162": {
        "startTime": 1181.408,
        "endTime": 1191.508,
        "transcript": "I don't think AVCP is boycotting, not to rejoin AFN, and it's on the agenda.",
        "translation": "I don't think AVCP is boycotting, not to rejoin AFN, and it's on the agenda."
    },
    "163": {
        "startTime": 1191.512,
        "endTime": 1204.363,
        "transcript": "What I think what I think AVCP wants is true representation of our desires if we are to go back to AFN.",
        "translation": "What I think what I think AVCP wants is true representation of our desires if we are to go back to AFN."
    },
    "164": {
        "startTime": 1204.375,
        "endTime": 1216.025,
        "transcript": "And I think using the example of the 1991 process, AVCP had some specific issues that we wanted AFN to address.",
        "translation": "And I think using the example of the 1991 process, AVCP had some specific issues that we wanted AFN to address."
    },
    "165": {
        "startTime": 1216.045,
        "endTime": 1221.933,
        "transcript": "But, on the eleventh hour, our concerns weren't heard.",
        "translation": "But, on the eleventh hour, our concerns weren't heard."
    },
    "166": {
        "startTime": 1221.945,
        "endTime": 1229.533,
        "transcript": "And for that reason, we did not go back to AFN, among others.",
        "translation": "And for that reason, we did not go back to AFN, among others."
    },
    "167": {
        "startTime": 1229.546,
        "endTime": 1241.359,
        "transcript": "But that was the primary reason. I think if AVCP is to rejoin AFN, the AVCP leadership needs to sit down with AVCP leadership",
        "translation": "But that was the primary reason. I think if AVCP is to rejoin AFN, the AVCP leadership needs to sit down with AVCP leadership"
    },
    "168": {
        "startTime": 1241.368,
        "endTime": 1253.668,
        "transcript": "And discuss how representation would have to occur, and AVCP needs to be involved in such a statewide organization.",
        "translation": "And discuss how representation would have to occur, and AVCP needs to be involved in such a statewide organization."
    },
    "169": {
        "startTime": 1254.447,
        "endTime": 1257.684,
        "transcript": "Do you have any additional comments you want to [?].",
        "translation": "Do you have any additional comments you want to [?]."
    },
    "170": {
        "startTime": 1258.755,
        "endTime": 1265.705,
        "transcript": "I guess, as far as the convention here, the 2005th annual convention of AVCP",
        "translation": "I guess, as far as the convention here, the 2005th annual convention of AVCP"
    },
    "171": {
        "startTime": 1265.714,
        "endTime": 1278.514,
        "transcript": "This, I view as a turning point where our people are beginning to understand that we need to work together as a united group of villages.",
        "translation": "This, I view as a turning point where our people are beginning to understand that we need to work together as a united group of villages."
    },
    "172": {
        "startTime": 1278.528,
        "endTime": 1290.926,
        "transcript": "Whatever forum the unification comes out of, we need to support it indivdually and orginazaniolly in order for it to succeed for our desires.",
        "translation": "Whatever forum the unification comes out of, we need to support it indivdually and orginazaniolly in order for it to succeed for our desires."
    },
    "173": {
        "startTime": 1290.94,
        "endTime": 1293.04,
        "transcript": "(Quyana.) Quyana.",
        "translation": "(Thank you.) Thank you."
    },
    "174": {
        "startTime": 1293.06,
        "endTime": 1294.335,
        "transcript": "Yugtun-llu pinrilnguten.",
        "translation": "You should've spoken in Yup'ik."
    },
    "175": {
        "startTime": 1294.34,
        "endTime": 1296.69,
        "transcript": "[?] cover-allra.",
        "translation": "The [?] that it covered."
    }
};